<mat-form-field appearance="outline" [floatLabel]="floatLabel">
    <mat-label>
        <ng-content select="aum-form-field-label"></ng-content>
    </mat-label>
    <input
        #input
        matInput
        [matDatepicker]="picker"
        [placeholder]="placeholder"
        autocomplete="nothing"
        [formControl]="aumFormControl"
    />
    <mat-icon
        matSuffix
        *ngIf="aumFormControl!=null && aumFormControl.invalid && aumFormControl.touched"
        class="triangle-warning"
        svgIcon="aumico-pattern-icon-alert-triangle"
    ></mat-icon>
    <mat-datepicker-toggle matSuffix [for]="picker">
        <mat-icon matDatepickerToggleIcon svgIcon="aumico-pattern-icon-calendar"></mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error *ngIf="aumFormControl && aumFormControl.invalid">
        <ng-content select="aum-form-error"></ng-content>
    </mat-error>
</mat-form-field>
